// extracted by mini-css-extract-plugin
export default {"ExpandableTable":"integrationsTable_ExpandableTable__K1LDW","selectedExpandIcon":"integrationsTable_selectedExpandIcon__0lZEh","expandIcon":"integrationsTable_expandIcon__KvFqZ"};